'use client';

import React__default from 'react';
import { Container, Content } from './styles.js';

var AspectRatio = function (_a) {
    var ratio = _a.ratio, maxWidth = _a.maxWidth, children = _a.children;
    var ratioInPercent = Math.pow(ratio, -1) * 100;
    return (React__default.createElement(Container, { maxWidth: maxWidth, ratioInPercent: ratioInPercent },
        React__default.createElement(Content, null, children)));
};

export { AspectRatio as default };
//# sourceMappingURL=index.js.map
